import { render } from "./Videoplay.vue?vue&type=template&id=1b21d44e"
import script from "./Videoplay.vue?vue&type=script&lang=js"
export * from "./Videoplay.vue?vue&type=script&lang=js"

import "./Videoplay.vue?vue&type=style&index=0&id=1b21d44e&lang=scss"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__